module.exports = __webpack_public_path__ + "media/images/ioscor_canal2-63283b4d7ad4b0f3fabb88f560913fde.svg";